<template>
  <DatatableReportV3
    ref="report"
    :source="source"
    :config="config"
    :filters="filters"
    title="Vehicles"
    use-datatable-export-csv
  >
<template #actions>
<slot name="actions">
      <a href="/vehicles/new" class="flex overflow-hidden gap-2 justify-center items-center px-5 py-2.5 !rounded-lg border text-white bg-blue-700 border-blue-700 hover:bg-blue-800">
        <i class="fa fa-plus fa-fw"></i> Add Vehicle
      </a>
    </slot>
  </template>    
  </DatatableReportV3>
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          { data: "title", title: "Title", responsivePriority: 1 },
          { data: "color", title: "Color", responsivePriority: 11 },
          {
            data: "user",
            title: "Checked Out To",
            filterName: "technician_id",
            responsivePriority: 2
          },
          {
            data: "date_purchased",
            title: "Date Purchased",
            responsivePriority: 10
          },
          {
            data: "licence_plate_number",
            title: "License Plate #",
            responsivePriority: 3
          },
          { data: "vin", title: "VIN #", responsivePriority: 4 },
          {
            data: "last_serviced",
            title: "Last Serviced",
            responsivePriority: 6
          },
          {
            data: "last_serviced_mileage",
            title: "Last Serviced Mileage",
            searchable: false,
            responsivePriority: 9
          },
          {
            data: "current_miles",
            title: "Current Miles",
            searchable: false,
            responsivePriority: 7
          },
          {
            data: "inspection_sticker",
            title: "Inspection Sticker",
            responsivePriority: 8
          },
          {
            data: "inspection_date",
            title: "Inspection Date",
            responsivePriority: 5
          },
          {
            data: "actions",
            title: "",
            sortable: false,
            searchable: false
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
